import { getAuth, signOut } from 'firebase/auth'
import { useLocation } from 'react-router-dom'
import { Button, Stack, styled } from '@mui/material'
import { HelpOutline, LogoutOutlined } from '@mui/icons-material'
import Cookies from 'universal-cookie/es6'
import ProfileDropDown from './ProfileDropDown'
import logger from '../../../../utils/logger'
import config, { superUglyHackToClearAllCookies } from '../../../../config'
import { authenticatedUserVar } from '../../../../providers/apollo/cache'

const StyledStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: '16px',
  '.MuiButton-root': {
    gap: '4px',
    padding: 0,
    color: '#727C8C',
    fontSize: '0.875rem',
    fontWeight: 500,
    textDecoration: 'none',
    '.MuiListItemIcon-root': {
      minWidth: 0,
      color: '#727C8C',
      '.MuiSvgIcon-root': {
        maxWidth: '20px'
      }
    },
    '&:hover': {
      background: 'transparent',
      color: theme.palette.primary.main,
      '.MuiListItemIcon-root': {
        color: theme.palette.primary.main
      }
    }
  }
}))

export default function SettingsMenu() {
  const location = useLocation()
  const { pathname } = location
  const isSubscriptionPath = pathname.includes('/subscription')
  const isSharePath = pathname.includes('/share')
  const isNonBucketPath = pathname.includes('/settings') || pathname.includes('/buckets')

  const handleLogout = async () => {
    try {
      const auth = getAuth()
      await signOut(auth)
    } catch (error) {
      logger.error(error)
    }

    const cookies = new Cookies()
    cookies.remove('app_auth', config.cookieOptions)
    superUglyHackToClearAllCookies.forEach((cookieConfig) => cookies.remove('app_auth', cookieConfig))
    cookies.remove('facebook_dtp', config.cookieOptions)
    superUglyHackToClearAllCookies.forEach((cookieConfig) => cookies.remove('facebook_dtp', cookieConfig))
    localStorage.removeItem('reduxPersist:auth')
    localStorage.removeItem('_pb_userData:username')
    authenticatedUserVar(null)
    window.location.href = '/?logout=true'
  }

  if (!getAuth().currentUser) {
    return null
  }

  return (
    <>
      {!isSubscriptionPath && !isSharePath ? (
        isNonBucketPath && (
          <StyledStack>
            <Button onClick={() => window.open('https://support.photobucket.com/hc/en-us', '_blank')}>
              <HelpOutline />
              Support
            </Button>
            <Button onClick={handleLogout} variant="text">
              <LogoutOutlined />
              Logout
            </Button>
          </StyledStack>
        )
      ) : (
        <ProfileDropDown />
      )}
    </>
  )
}
